<template>
  <div class="news-box">
    <div class="pc">
      <div class="news-top">热门资讯</div>
      <div class="news-list flex flex-wrap justify-between">
        <div
          class="news flex flex-direction justify-between"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <div class="text-box">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="date">{{ item.date }}</div>
          </div>
          <div
            class="more flex align-center justify-start cs"
            @click="didClick_news(item)"
          >
            <span>查看详情</span>
            <img :src="rightArrowUrl" />
          </div>
        </div>
      </div>
    </div>
    <div class="wap">
      <div class="news-top">热门资讯</div>
      <div class="list flex flex-direction">
        <div class="swiper-parallel-news-wap flex">
          <div class="swiper-wrapper flex">
            <div
              class="swiper-slide flex"
              style="
                transform: translate3d(0, 0, 0);
                overflow: hidden;
                width: 100%;
                height: calc(100% - 30px);
              "
              v-for="(news, index) in newsList"
              :key="index"
              @mouseenter="currentNews = index"
              @click="currentNews = index"
            >
              <div class="slide flex flex-direction justify-between">
                <div class="text-box">
                  <div class="title">
                    {{ news.title }}
                  </div>
                  <div class="date">{{ news.date }}</div>
                </div>
                <div class="more-box" style="justify-self: end">
                  <div class="more cs">
                    <div class="text">查看详情</div>
                    <img src="../../assets/images/agenda/home/red-arrow.png" />
                  </div>
                </div>
                <!--                <div class="more flex align-center justify-start cs">-->
                <!--                  <span>查看详情</span>-->
                <!--                  <img :src="rightArrowUrl" />-->
                <!--                </div>-->
              </div>
            </div>
          </div>
          <!--     小圆点分页器       -->
          <div
            class="swiper-pagination-video-wap flex align-center justify-center"
            slot="pagination"
            style="width: 100%; height: 20px"
          ></div>
        </div>
      </div>
    </div>
    <DidLink :isHaveLine="false" @click.native="lookMore"></DidLink>
  </div>
</template>

<script>
import { Swiper } from "vue-awesome-swiper";
import { staticApi } from "../../services";
var self;
export default {
  name: "News",
  data() {
    return {
      rightArrowUrl: require("../../assets/images/sandbox/rightArrow.png"),
      swiper_news_wap: null,
      newsList: [],
    };
  },
  components: {},
  mounted() {
    self = this;
    this.getNewsList(); //获取热门资讯列表
    this.$bus.$on("reSwiper", (res) => {
      //初始化 swiper 方法 ↓
      var h = document.documentElement.clientWidth; //获取页面可见高度
      if (this.swiper_news_wap) {
        this.swiper_news_wap.init();
      }
    });
  },
  methods: {
    //获取热门资讯列表
    getNewsList() {
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.seminarId}/article/list/${this.$config.newsId}.json`
        )
        .then((res) => {
          if (res.result === 0) {
            let newsList = res.content.items;
            for (const item of newsList) {
              item.date = this.formatTime(
                new Date(item.pushTime * 1000),
                "YYYY/MM/DD"
              );
              if (item.showImagesRealPath[0]) {
                item.showImagesRealPath[0] = item.showImagesRealPath[0].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
              if (item.showImagesRealPath[1]) {
                item.showImagesRealPath[1] = item.showImagesRealPath[1].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
              if (item.summary.indexOf("^source=") > 1) {
                item.summaryChange = item.summary.substring(
                  0,
                  item.summary.indexOf("^source=")
                );
              } else {
                item.summaryChange = item.summary;
              }
              if (this.$config.articleRelation[item.title]) {
                item.url = this.$config.articleRelation[item.title];
              }
            }
            //筛选
            let newsList1 = newsList.filter((a) => {
              return a.isRecommend == 1;
            });
            //时间排序
            newsList1.sort((a, b) => {
              return a.pushTime - b.pushTime;
            });
            //位置排序
            newsList1.sort((a, b) => {
              return b.order - a.order;
            });
            if (newsList1.length < 4) {
              this.newsList = newsList1;
              this.$nextTick(() => {
                // 初始化swiper
                this.loadSwiper();
              });
            } else {
              this.newsList = newsList1.slice(0, 4);
              this.$nextTick(() => {
                // 初始化swiper
                this.loadSwiper();
              });
            }
          }
        })
        .catch((err) => {
          console.error("获取列表失败", err);
        });
    },
    loadSwiper() {
      this.swiper_news_wap = new Swiper(".swiper-parallel-news-wap", {
        loop: true, //首尾循环
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-video-wap",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active2",
        },
        on: {
          init() {},
          click(e) {
            const realIndex = this.realIndex;
            self.didClick_news(self.newsList[realIndex]);
          },
        },
      });
    },
    //查看详情 外链
    didClick_news(item) {
      //埋码
      window._hw("send", "action", "branch_venue_page_news_btn_click", {
        news_name: item.title, // 内容名称
      });
      window.open(item.url);
    },
    //查看更多
    lookMore() {
      window._hw("send", "action", "branch_venue_page_check_more_all_click");
      this.$router.push({
        path: "/news-list",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  .news-box {
    width: 1500px;
    padding-bottom: 100px;
    .pc {
      margin-top: 50px;
      .news-top {
        font-size: 32px;
        font-family: Microsoft YaHei-Light;
        font-weight: bold;
        width: 130px;
        padding-bottom: 15px;
        background: url("../../assets/images/parallelSessions/title-border-pc.png");
        background-size: 130px 5px;
        background-repeat: no-repeat;
        background-position: bottom;
      }
      .news-list {
        width: 1500px;
        .news {
          margin-top: 22px;
          padding: 38px 38px 34px 38px;
          width: 725px;
          height: 200px;
          background-image: url("../../assets/images/parallelSessions/news-bg.png");
          background-repeat: no-repeat;
          background-position: 0 0;
          background-size: 100%;
          .text-box {
            .title {
              width: 504px;
              font-size: 18px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #151e26;
              line-height: 30px;
            }
            .date {
              margin-top: 16px;
              font-size: 16px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #999999;
            }
          }
          .more {
            height: 24px;
            font-size: $font-xl;
            font-family: Microsoft YaHei-Light, Microsoft YaHei;
            font-weight: 300;
            color: #b4251e;
            line-height: 24px;
            span {
              line-height: 1;
            }
            img {
              margin-left: 13px;
              width: 22px;
            }
          }
        }
      }
    }
    .wap {
      display: none;
    }
  }
}
@media screen and (max-width: 992px) {
  .news-box {
    margin-top: 60px;
    margin-bottom: 37px;
    .pc {
      display: none;
    }
    .wap {
      .news-top {
        margin-left: 35px;
        font-size: 28px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #151e26;
        padding-bottom: 15px;
        background: url("../../assets/images/parallelSessions/title-border-pc.png");
        background-repeat: no-repeat;
        background-position: bottom left;
        background-size: 117px 4.5px;
      }
      .list {
        margin-top: 37px;
        width: 100%;
        height: 380px;

        overflow: hidden;
        ::v-deep .swiper-parallel-news-wap {
          position: relative;
          width: 100%;
          height: 100%;
          .swiper-slide {
            width: 600px !important;
            margin: 0 2%;
          }
          .swiper-slide-active {
            transition: 200ms;
            //transform: scale(1) !important;
          }
          .swiper-slide-prev {
            right: 1%;
            border: 2px solid;
            border-image: linear-gradient(
                160deg,
                rgba(255, 255, 255, 1),
                rgba(235, 235, 235, 0),
                rgba(235, 235, 235, 0),
                rgba(255, 255, 255, 0.62)
              )
              2 2;
            //transition: 200ms;
            //transform: scale(0.9) !important;
          }
          .swiper-slide-next {
            left: 1%;
            border: 2px solid;
            border-image: linear-gradient(
                160deg,
                rgba(255, 255, 255, 1),
                rgba(235, 235, 235, 0),
                rgba(235, 235, 235, 0),
                rgba(255, 255, 255, 0.62)
              )
              2 2;
            //transition: 200ms;
            //transform: scale(0.9) !important;
          }
          .swiper-pagination-video-wap {
            position: absolute;
            bottom: 0px;
            left: 0;
            z-index: 10;
          }
          .my-bullet {
            width: 26px;
            height: 8px;
            background: #c4c4c4;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            margin: 0 5px;
          }
          .my-bullet-active2 {
            background: #b4251e;
          }
        }
        .slide {
          width: 100%;
          padding: 48px 42px 72px 42px;
          box-sizing: border-box;
          position: relative;
          background-image: url("../../assets/images/parallelSessions/news-bg.png");
          background-repeat: no-repeat;
          background-position: 0 0;
          background-size: 100% 100%;

          .text-box {
            .title {
              width: 523px;
              font-size: 28px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: bold;
              color: #151e26;
              line-height: 42px;
            }
            .date {
              margin-top: 24px;
              width: 186px;
              font-size: 22px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #999999;
            }
          }
          .more-box {
            // height: 60px;
            margin-top: 30px;
            //border: 1px solid #b4251e;
            .more {
              height: 35px;
              font-size: 24px;
              font-family: Microsoft YaHei-Light;
              font-weight: 400;
              display: flex;
              align-items: center;

              color: #b4251e;
              line-height: 35px;
              img {
                width: 41px;
                height: 16px;
                margin-left: 20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
